export const USER_QUERY_KEYS = {
  GET_USERS: 'GET_USERS',
  GET_APPROVERS: 'GET_APPROVERS',
  GET_USER_DATA: 'GET_USER_DATA',
} as const;
